import isRunningInExtension from './isRunningInExtension';

export default (): boolean =>
  isRunningInExtension() && typeof chrome.runtime.onInstalled !== 'undefined';
